import { createFileRoute, redirect } from "@tanstack/react-router";

// DEPRECATED (product, 2026-05-19): donor detail is now an overlay modal on
// the Donors list (and Call Time), not a dedicated page. This route is kept
// as a redirect so old deep links / bookmarks open the modal on /fundraising
// via ?donorId=. The detail UI lives in components/fundraising/
// DonorDetailModal.tsx; the DonorInteractions/DonorCallHistory sections and
// useDonorDetail hook are unchanged.
export const Route = createFileRoute("/_app/_/fundraising/donors/$donorId")({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/fundraising",
			search: { donorId: Number(params.donorId) },
		});
	},
});
